import { MODAL_TYPE, showModal } from '../../../../shared/components/modals/generic_modal_conductor';
import RenameSavedReportMutation from '../../../../../mutations/rename_saved_report_mutation';
import Util from '../../../../shared/util/util';
const renameReportMutation = (report, successCallback, name) => {
    Util.CommitMutation(RenameSavedReportMutation, {
        id: report.id,
        reportService: report.reportService,
        name: name,
    }, successCallback);
};
export const renameReport = (report, successCallback) => {
    showModal({
        type: MODAL_TYPE.RENAME_REPORT_MODAL,
        reportName: report.name,
        renameReport: renameReportMutation.bind(this, report, successCallback),
    });
};
